module.exports = __webpack_public_path__ + "img/37d1f1e039448f2635c98b6015d2208a.png";